import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SmartBriefConversation } from './molecules/conversation/smart-brief-conversation';
import { SmartBriefDraftWrite } from './smart-brief-draft';

export type SmartBriefDraftRecord = {
  id: string;
  status: 'in-progress' | 'abandoned' | 'completed';
  conversation: SmartBriefConversation;
  composerText: string;
  campaignId: string | null;
  pricingModelId: string | null;
  briefId: string | null;
};

@Injectable({ providedIn: 'root' })
export class SmartBriefDraftService {
  private readonly http = inject(HttpClient);

  load(businessAccountId: string): Observable<SmartBriefDraftRecord | null> {
    return this.http.get<SmartBriefDraftRecord | null>(`${environment.shout_api.url}/briefs/smart-draft`, {
      params: { businessAccountId },
    });
  }

  save(body: SmartBriefDraftWrite): Observable<SmartBriefDraftRecord | null> {
    return this.http.post<SmartBriefDraftRecord | null>(`${environment.shout_api.url}/briefs/smart-draft`, body);
  }

  abandon(businessAccountId: string): Observable<SmartBriefDraftRecord | null> {
    return this.http.post<SmartBriefDraftRecord | null>(`${environment.shout_api.url}/briefs/smart-draft/abandon`, {
      businessAccountId,
    });
  }

  complete(businessAccountId: string, briefId: string): Observable<SmartBriefDraftRecord | null> {
    return this.http.post<SmartBriefDraftRecord | null>(`${environment.shout_api.url}/briefs/smart-draft/complete`, {
      businessAccountId,
      briefId,
    });
  }
}
